import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../Menus/EditCloneDeleteMenu";
import {CheckBox, Check} from "@mui/icons-material";


export const DataPointValueGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: '',
        sortable: true,
        width: 60,
        hide: false,
    },

    {
        field: 'name',
        headerName: 'Name',
        description: '',
        sortable: false,
        editable: true,
        width: 300,
        // renderCell: (dataPointValues) => {
        //     return (
        //         <p onClick= {() => handleDrilldown(dataPointValues.row.id, dataPointValues.row.mcode, dataPointValues.row.name, dataPointValues.row.description, dataPointValues.row.dataPoint, dataPointValues.row.ordinalNumber, dataPointValues.row.exceptionInd,dataPointValues.row)}>
        //             {dataPointValues.row.name} </p>
        //     );
        // }

    },
    {
        field: 'description',
        headerName: 'Description',
        description: '',
        sortable: false,
        editable: true,
        width: 500,
        // renderCell: (dataPointValues) => {
        //     return (
        //         <p onClick= {() => handleDrilldown(dataPointValues.row.id, dataPointValues.row.mcode, dataPointValues.row.name, dataPointValues.row.description, dataPointValues.row)}>
        //             {dataPointValues.row.description} </p>
        //     );
        // }
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: '',
        sortable: true,
        editable: true,
        hide: false,
        width: 200,
    },
    {
        field: 'dataPointId',
        headerName: 'DP ID',
        description: '',
        sortable: false,
        renderCell: (dataPointValues) => {
            return <div className="rowitem">{dataPointValues.row.dataPointId}</div>;},
        width: 50,
    },
    {
        field: 'dataPointName',
        headerName: 'Data Point',
        description: '',
        sortable: false,
        renderCell: (dataPointValues) => {
            return <div className="rowitem">{dataPointValues.row.dataPointName}</div>;},
        width: 500,
    },
    // {
    //     field: 'exceptionInd',
    //     headerName: 'Exception',
    //     formatter: CheckBox,
    // },
    {
        field:  'exceptionInd',
        headerName: 'Exception',
        renderCell: (dataPointValues) =>
        {
            if(dataPointValues.row.exceptionInd === true ){
                return (
                    <Tooltip title={"Data Point Value  is flagged as an exception."}>
                        <Check/>
                    </Tooltip>)}

            if(dataPointValues.row.exceptionInd === false ){
                return (
                    <p/>
                )}
        },
        description: '',
        sortable: false,
        width: 100,
    },
    {
        field: 'ordinalNumber',
        headerName: 'Order',
        description: '',
        width: 200,
    },
    {
        field: 'status',
        headerName: 'Status',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'createdOn',
        headerName: 'createdOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'createdBy',
        headerName: 'createdBy',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedOn',
        headerName: 'lastModifiedOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedBy',
        headerName: 'lastModifiedBy',
        description: '',
        width: 100,
        hide: true
    },
];
